/* Ported from the live theme's core.js — always loaded, no Three.js/GSAP
   dependency, so mobile never touches that code path. Menu, footer year,
   "Nosotros"/"Intermediación" corridor jumps, RUM, contact form. */

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());

const navToggle = document.getElementById('nav-toggle');
const mainNav = document.getElementById('main-nav');
const isEN = document.documentElement.lang === 'en';

if (navToggle && mainNav) {
  navToggle.addEventListener('click', () => {
    const open = mainNav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', String(open));
    navToggle.setAttribute('aria-label', open ? (isEN ? 'Close menu' : 'Cerrar menú') : (isEN ? 'Open menu' : 'Abrir menú'));
  });
  mainNav.querySelectorAll('.navlink').forEach((a) => {
    a.addEventListener('click', () => {
      mainNav.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
    });
  });
}

// "Nosotros" / "Intermediación" live inside the pinned 3D corridor, which has
// no real document position to anchor to — compute the scroll offset that
// corresponds to that point in the camera path instead of a plain <a href>.
document.querySelectorAll('[data-corridor-progress]').forEach((a) => {
  a.addEventListener('click', (e) => {
    e.preventDefault();
    const target = parseFloat(a.dataset.corridorProgress);
    if (window.matchMedia('(min-width:769px)').matches) {
      if (window.ScrollTrigger) {
        const st = window.ScrollTrigger.getAll().find((t) => t.pin);
        if (st) st.scroll(st.start + (st.end - st.start) * target);
      }
    } else {
      const el = document.querySelector(target < 0.7 ? '.act-1' : '.act-2');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Real-user Web Vitals → GA4 (native PerformanceObserver, no vendor lib).
(function () {
  function send(name, value, extra) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, Object.assign({ value: Math.round(value) }, extra || {}));
  }
  try {
    new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const last = entries[entries.length - 1];
      if (last) send('web_vitals_lcp', last.renderTime || last.loadTime || last.startTime);
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch {}
  try {
    let clsValue = 0;
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (!entry.hadRecentInput) clsValue += entry.value;
      });
    }).observe({ type: 'layout-shift', buffered: true });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') send('web_vitals_cls', clsValue * 1000);
    }, { once: true });
  } catch {}
  try {
    let worst = 0;
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.duration > worst) worst = entry.duration;
      });
    }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden' && worst > 0) send('web_vitals_inp_approx', worst);
    }, { once: true });
  } catch {}
})();

// Contact form → Cloudflare Pages Function (replaces WP admin-ajax/wp_mail).
// Progressive enhancement: the <form> has a real action/method, so a no-JS
// POST still reaches the same endpoint.
(function () {
  const form = document.getElementById('contact-form');
  if (!form) return;
  const status = document.getElementById('cf-status');
  const submitBtn = form.querySelector('button[type="submit"]');
  const msgs = isEN
    ? { sending: 'Sending…', ok: "Thanks — we'll be in touch soon.", err: 'Something went wrong — try emailing us directly at office@vantalus.com.' }
    : { sending: 'Enviando…', ok: 'Gracias — te responderemos pronto.', err: 'Algo ha fallado — escríbenos directamente a office@vantalus.com.' };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    submitBtn.disabled = true;
    status.textContent = msgs.sending;
    fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form))),
    })
      .then((r) => r.json())
      .then((data) => {
        status.textContent = data && data.ok ? msgs.ok : msgs.err;
        if (data && data.ok) form.reset();
      })
      .catch(() => { status.textContent = msgs.err; })
      .finally(() => { submitBtn.disabled = false; });
  });
})();

// Corredor 3D (Three.js + GSAP, ~785KB): solo desktop, cargado bajo demanda
// via dynamic import — igual que el loader inline de functions.php, pero
// resuelto por el bundler en vez de <script src> manuales.
if (window.matchMedia('(min-width:769px)').matches) {
  import('./corridor.js');
}
